module.exports = function anonymous(locals, escapeFn, include, rethrow
/**/) {
"use strict";
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
        .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
  var __output = [], __append = __output.push.bind(__output);
    ; __append("<div class=\"modal-dialog modal-md create-api-key-modal\"> <div class=\"modal-content\"> <section class=\"modal-header\"> <button type=\"button\" class=\"close\" data-dismiss=\"modal\"><span>&times;</span></button> <h4><b>Create New API Key</b></h4> </section> <form class=\"form-horizontal\"> <section class=\"modal-body\"> <h4>What type of API Key would you like to create?</h4> <div> <div class=\"radio\"> <label><input type=\"radio\" name=\"api-key-type\" value=\"production\" checked=\"checked\">Production</label> </div> <div class=\"radio\"> <label><input type=\"radio\" name=\"api-key-type\" value=\"test\">Test</label> </div> </div> </section> <section class=\"modal-footer\"> <button class=\"btn btn-red cancel\" type=\"button\">Cancel</button> <button class=\"btn btn-blue create-api-key\" type=\"button\">Create Key</button> </section> </form> </div> </div> ")
  return __output.join("");

}


//////////////////
// WEBPACK FOOTER
// ./templates/create_api_key_modal.ejs
// module id = 842
// module chunks = 1